import { render } from "./RareDiseaseTreatmentPatternInterventions.vue?vue&type=template&id=62b7a37f&scoped=true"
import script from "./RareDiseaseTreatmentPatternInterventions.vue?vue&type=script&lang=js"
export * from "./RareDiseaseTreatmentPatternInterventions.vue?vue&type=script&lang=js"

import "./RareDiseaseTreatmentPatternInterventions.vue?vue&type=style&index=0&id=62b7a37f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b7a37f"]])

export default __exports__